<template>
  <CModal
    title="Chỉnh sửa bảo hành"
    :show.sync="showing"
    :closeOnBackdrop="false"
    centered
  >
    <p class="font-weight-bold">{{ productName }}</p>
    <CRow>
      <CCol md="12" v-for="(item, i) in items" :key="`warranty-${i}`">
        <CInput
          type="number"
          :label="`${$const.WARRANTY_TYPES_TEXT[item.WarrantyType]} (tháng)`"
          min="0"
          :value="item.Months"
          @input="(e) => (item.Months = e ? parseInt(e) : 0)"
          @focus="(e) => e.target.select()"
        />
      </CCol>
    </CRow>
    <template v-slot:footer>
      <button type="button" class="btn btn-secondary" @click="showing = false">
        Hủy
      </button>
      <button type="button" class="btn btn-primary" @click="okHandle">
        Đồng ý
      </button>
    </template>
  </CModal>
</template>

<script>
export default {
  props: ["updating", "editingWarranties", "productName"],
  data() {
    return {
      showing: false,
      items: [],
    };
  },
  watch: {
    editingWarranties: {
      deep: true,
      handler(val) {
        this.items = (val || []).map((_) => Object.assign({}, _));
      },
    },

    updating(val) {
      this.showing = val;
    },
    showing(val) {
      this.$emit("update:updating", val);
    },
  },
  methods: {
    okHandle() {
      this.$emit("choose", this.items);
      this.showing = false;
    },
  },
};
</script>
